import React, { useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import '../Features.css';

const Speech = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.getElementById('home').classList.add('featureContent');
    return () => {
      document.getElementById('home').classList.remove('featureContent');
    };
  });
  useEffect(() => {
    setTimeout(() => {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }, 100);
  }, []);
  return (
    <Container className="featurePages speech">
      <div className="header">
        <div className="headerContent">
          <h2 className="title">{t('contents:speechTitle1')}</h2>
          <p className="text">
            {t('contents:speechParagraph1')}
            <br />
            {t('contents:speechParagraph2')}
          </p>
        </div>
        <img src={require('../../../assets/images/features/pages/speech/speech_01.png')} />
      </div>
      <div className="content">
        <div className="container">
          <div className="section section01">
            <div className="textBox">
              <p>
                {t('contents:speechParagraph3')}
                <br />
                <br />
                {t('contents:speechParagraph4')}
              </p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/speech/speech_05.png')} />
            </div>
          </div>
          <div className="section section02">
            <div className="textBox">
              <h2 className="title">{t('contents:speechTitle2')}</h2>
              <p>{t('contents:speechParagraph5')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/speech/speech_06.png')} />
            </div>
          </div>
          <div className="section section03">
            <div className="textBox">
              <h2 className="title">{t('contents:speechTitle3')}</h2>
              <p>{t('contents:speechParagraph6')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/speech/speech_07.png')} />
            </div>
          </div>
          <div className="section section04">
            <div className="textBox">
              <h2 className="title">{t('contents:speechTitle5')}</h2>
              <p>{t('contents:speechParagraph8')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/speech/speech_08.png')} />
            </div>
          </div>
          <div className="section section05">
            <div className="textBox">
              <h2 className="title">{t('contents:speechTitle4')}</h2>
              <p>{t('contents:speechParagraph7')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/speech/speech_09.png')} />
            </div>
          </div>
          <div className="section section06">
            <div className="textBox">
              <h2 className="title">{t('contents:speechTitle6')}</h2>
              <p>{t('contents:speechParagraph9')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/speech/speech_10.png')} />
            </div>
          </div>
        </div>
        <div className="footer"></div>
      </div>
    </Container>
  );
};

export default Speech;
